import _ from 'lodash';
import BalanceApi from '../../api/BalanceApi';

const state = {
  balances: [],
  cardDebts: [],
};

const getters = {
  hasBalance: state => !_.isEmpty(state.balances),
  hasCreditCardDebt: state => !_.isEmpty(state.cardDebts),
};

const actions = {
  async init({ commit }) {
    const balances = await BalanceApi.fetchBalances();
    const cardDebts = await BalanceApi.fetchCardDebts();
    commit('setBalances', balances);
    commit('setCardDebts', cardDebts);
  },
};

// mutations
const mutations = {
  setBalances(state, balances) {
    state.balances = balances; // eslint-disable-line
  },
  setCardDebts(state, cardDebts) {
    state.cardDebts = cardDebts; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/balance.js